export enum ExperienceChangeType {
    Other = 0,
    FixError = 1,
    InitialReview = 2,
}

export const ExperienceChangeTypeOptions = [
    { id: ExperienceChangeType.Other, name: 'Other Mod.', sortOrder: 2 },
    { id: ExperienceChangeType.FixError, name: 'Fix Error', sortOrder: 3 },
    { id: ExperienceChangeType.InitialReview, name: 'Initial Review', sortOrder: 1 },
];
